interface IAiDeleteConversationMessageProps {
  title: string;
}

/** The delete confirmation's text; the title renders as text, never as HTML. */
export const AiDeleteConversationMessage = ({ title }: IAiDeleteConversationMessageProps) => {
  return (
    <span>
      Да изтрия ли разговора „<strong>{title}</strong>“? Това не може да бъде отменено.
    </span>
  );
};
